import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";

//Components
import {
    Container,
    Breadcrumb,
    LinearProgress
} from "@gpstrackit/gtc-react-controls";

import { Grid, Paper, Skeleton } from '@mui/material';
import { TagsGroup } from "../../../../components/Tag";
import { Tabs, TabContainer, IconButton } from "@gpstrackit/gtc-react-controls";
import Collapse from '@mui/material/Collapse';

//Containers
import Preferences from "Core/containers/Preferences";

//Actions
import { openModalCreateEditCustomer, openModalDeleteCustomer, savePreference } from 'Redux/actions'
import { workOrdersCustemerDetailGetCustomers } from './redux/slice'

//Styles
import './index.scss'

//Views
import CreateEditCustomer from '../../views/customerTab/modals/createEditCustomer';
import DeleteCustomer from '../../views/customerTab/modals/deleteCustomer';
import WorkOrder from '../workOrderTab';
import Locations from '../locationTab';
import Contacts from '../contactTab';
const CustomerDetail = () => {

    const { messages } = useIntl()

    //Hooks
    const dispatch = useDispatch();
    const navigate = useNavigate();

    // Params
    const { id } = useParams();

    // Redux States
    const openModalCustomer = useSelector((state) => state.workOrdersCreateEditCustomerRedux.open);
    const { customer, loading } = useSelector((state) => state.workOrdersCustomerDetailRedux);
    const openModalDelete = useSelector((state) => state.workOrdersDeleteCustomerRedux.open);
    const authenticatedId = useSelector(state => state.securityRedux.authenticatedId);

    //Local States
    const [checked, setChecked] = useState(true);

    // Effects
    useEffect(() => {
        dispatch(workOrdersCustemerDetailGetCustomers({ id: id }))
    }, [])

    // Functions
    const getAddress = (data) => {
        let currentAddress = ''
        try {
            currentAddress = JSON.parse(data.address)
        } catch (error) { }
        return currentAddress?.address
    }

    const refreshOverview = () => {
        dispatch(workOrdersCustemerDetailGetCustomers({ id: id }))
    }

    const goBack = () => {
        navigate('/app/workorders/main')
    }
    // Tabs
    const tabs = [
        {
            label: messages['workOrder_customerDetail_workOrders'],
            id: "workOrders",
            component: <WorkOrder customerId={id} fullHeight={!checked} />,
        },
        {
            label: messages['workOrder_customerDetail_contacts'],
            id: "contacts",
            component: <Contacts customerId={id} fullHeight={!checked} />,
        },
        {
            label: messages['workOrder_customerDetail_locations'],
            id: "locations",
            component: <Locations customerId={id} fullHeight={!checked} />,
        }
    ];

    const handleChange = () => {
        const preferenceValue = { showDetails: !checked };
        setChecked(!checked);
        dispatch(savePreference({ entityName: "User", entityId: authenticatedId, preferenceKey: "customerDetail", preferenceValue: preferenceValue }));
    };

    return (
        <Container className="container-view">
            {loading && <LinearProgress />}
            <Paper elevation={0}>
                <Grid
                    container
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    style={{ padding: checked ? "15px 20px" : "15px 20px 0 20px" }}
                >
                    <Grid item xs>
                        <Breadcrumb
                            links={[
                                {
                                    title: messages['workOrder_customerDetail_customers'],
                                    link: "/app/workorders/main",
                                },
                                {
                                    title: customer?.name || '',
                                },
                            ]}
                            navigate={navigate}
                        />
                    </Grid>
                    <Grid item xs style={{ display: 'flex', justifyContent: 'end' }}>
                        <IconButton
                            icon="settings"
                            tooltip={messages['workOrder_customerDetail_edit']}
                            onClick={() => {
                                dispatch(openModalCreateEditCustomer({ customerId: id }))
                            }}
                        />
                        <IconButton
                            icon="delete"
                            tooltip={messages['workOrder_customerDetail_delete']}
                            onClick={() => {
                                dispatch(openModalDeleteCustomer({ customer: customer }))
                            }}
                        />
                        <IconButton
                            icon={checked ? "expand_less" : "expand_more"}
                            tooltip={checked ? messages['workOrder_customerDetail_hideDescription'] : messages['workOrder_customerDetail_showDescription']}
                            onClick={() => handleChange()}
                        />
                    </Grid>
                </Grid>
                {
                    loading ? (
                        <Skeleton
                            variant="rectangular"
                            animation="wave"
                            height='60px'
                            style={{ marginLeft: 10, marginRight: 10 }}
                        />
                    ) : (
                        <div style={{ marginLeft: 10, marginRight: 10 }}>
                            <Preferences
                                preferencesKey={"customerDetail"}
                                onInitialPreferences={(data) => {
                                    if (typeof data?.showDetails === "boolean") {
                                        setChecked(data?.showDetails);
                                    }
                                }}
                            >
                                <Collapse in={checked}>
                                    <Grid
                                        container
                                        direction="row"
                                        justifyContent="space-between"
                                        alignItems="center"
                                        className="customer-details-subheader"
                                    >

                                        <Grid item>
                                            <span className="customer-details-title">
                                                {messages['workOrder_customerDetail_name']}:
                                            </span>
                                            <span className="customer-details-content" style={{ marginRight: 10 }}>
                                                {customer?.name}
                                            </span>
                                        </Grid>

                                        <Grid item>
                                            <span className="customer-details-title">
                                                {messages['workOrder_customerDetail_ein']}:
                                            </span>
                                            <span className="customer-details-content" style={{ marginRight: 10 }}>
                                                {customer?.ein || 'N/A'}
                                            </span>
                                        </Grid>

                                        <Grid item>
                                            <span className="customer-details-title">
                                                {messages['workOrder_customerDetail_address']}:
                                            </span>
                                            <span className="customer-details-content" style={{ marginRight: 10 }}>
                                                {getAddress(customer?.customerLocation)}
                                            </span>
                                        </Grid>
                                        <Grid item>
                                            <span className="customer-details-title">
                                                {messages['workOrder_customerDetail_email']}:
                                            </span>
                                            <span className="customer-details-content" style={{ marginRight: 10 }}>
                                                {customer?.customerContact?.email}
                                            </span>
                                        </Grid>
                                        <Grid item>
                                            <span className="customer-details-title">
                                                {messages['workOrder_customerDetail_phone']}:
                                            </span>
                                            <span className="customer-details-content" style={{ marginRight: 10 }}>
                                                {customer?.customerContact?.phone}
                                            </span>
                                        </Grid>
                                        <Grid item>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "end",
                                                    marginRight: 8,
                                                }}
                                            >
                                                <div className="customer-details-title">
                                                    {messages['workOrder_customerDetail_tags']}
                                                </div>
                                                <div>
                                                    {
                                                        customer?.tagIds?.length ? (
                                                            <TagsGroup
                                                                options={(customer?.tagIds?.includes("-99") || customer?.tagIds?.includes(-99)) ? [{ id: -99, label: messages['tagPicker_allTagsAreSelected'], color: '#005bf8' }] : customer?.tags?.filter(tag => customer?.tagIds?.includes(tag.id))}
                                                                nameField="label"
                                                                colorField="color"
                                                            />
                                                        ) : <span className="customer-details-content">N/A</span>
                                                    }
                                                </div>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Collapse>
                            </Preferences>
                        </div>
                    )
                }
                <div className="customer-details-tabs">
                    <Tabs
                        tab={0}
                    >
                        {tabs.map((item, index) => {
                            const { label, component } = item;
                            return (
                                <TabContainer key={index} label={label} index={index}>
                                    {component}
                                </TabContainer>
                            );
                        })}
                    </Tabs>
                </div>
            </Paper>
            {openModalCustomer && <CreateEditCustomer refresh={refreshOverview} />}
            {openModalDelete && <DeleteCustomer single refresh={goBack} />}
        </Container>
    )
}

export default CustomerDetail